module.exports = "<p>\r\n  confirm-schedule works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-schedule-popup/confirm-schedule/confirm-schedule.component.html
// module id = ../../../../../src/app/content-page/admin/create-schedule-popup/confirm-schedule/confirm-schedule.component.html
// module chunks = main